<template>
	<v-container fluid>
		<compensi-component
			v-if="amIAdminOrTeamleader && computedClienteClickdayIt"
		></compensi-component>
	</v-container>
</template>


<script>
export default {

}
</script>